import { map } from "@thi.ng/transducers";
import { PRESET_NAMES, PresetName } from "../api";

export const presetComponent = (action: (presetName: PresetName) => void) => {
  return [
    "div",
    {},
    ["h3", "Presets"],
    [
      "div",
      {
        style: {
          display: "flex",
          "justify-content": "space-around",
          "flex-wrap": "wrap",
        },
      },
      ...Array.from(
        map(
          (presetName) => [
            "button",
            {
              style: {
                width: "100px",
                height: "60px",
                background: "rgb(50, 50, 50)",
                "margin-bottom": "20px",
                color: "rgb(220, 220, 220)",
                "font-size": "15px",
                "text-align": "center",
              },
              onclick: () => {
                action(presetName);
              },
            },
            presetName,
          ],
          PRESET_NAMES,
        ),
      ),
    ],
  ];
};
